<template>
  <div class="toexcel">
    <el-button
      @click="exportExcel"
      type="primary"
      class="button"
      style="
        width: 70px;
        height: 40px;
        position: absolute;
        top: 7px;
        right: 190px;
      "
      >导出</el-button
    >
  </div>
</template>

<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
// import { dataConversionUtil } from './data2Excel'
export default {
  name: "excel",
  data() {
    return {
      // data: [],
    };
  },
  created() {
    // this.data = JSON.parse(sessionStorage.getItem("list"));
    // console.log(this.data);
  },
  watch: {},
  mounted() {},
  destroyed() {},
  computed: {},
  methods: {
    exportExcel() {
      // 设置当前日期
      const time = new Date();
      const year = time.getFullYear();
      const month = time.getMonth() + 1;
      const day = time.getDate();
      const name = year + "" + month + "" + day;
      // console.log(name)
      /* generate workbook object from table */
      //  .table要导出的是哪一个表格
      var xlsxParam = { raw: true };
      var wb = XLSX.utils.table_to_book(
        document.querySelector(".table"),
        xlsxParam
      );
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
        time,
      });
      try {
        //  name+'.xlsx'表示导出的excel表格名字
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  background-color: white;
  color: #409eff;
  border: 1px solid #9dcdff;
  background-color: #f4f9ff;
  padding: 10px 18px;
}
.button:hover {
  color: #198afc;
  border: 1px solid #6eacee;
}
</style>
